<div style="padding-bottom: 24px">
    <p>{{ hinweisText }}</p>
    <canvas
        #signatureCanvas
        [ngClass]="{
            'signature-pad-mobile-portrait': isMobileDevice && isPortraitMode,
            'signature-pad-mobile-landscape': isMobileDevice && !isPortraitMode,
            'signature-pad-desktop-portrait': !isMobileDevice && isPortraitMode,
            'signature-pad-desktop-landscape': !isMobileDevice && !isPortraitMode
        }"
    ></canvas>
    <br />
    <button (click)="clear()" mat-button>L&ouml;schen</button>
    <button (click)="save()" [disabled]="!!imgBase64 && imgBase64.length > 0" color="accent" mat-button
        >Speichern
    </button>
</div>
